import { combineReducers } from "redux";
import { sentimentTrackerOnboardingReducer } from "./sentimentTrackerOnboarding/sentimentTrackerOnboardingReducer";

const sentimentTrackerRootReducer = combineReducers({
    sentimentTrackerOnboarding: sentimentTrackerOnboardingReducer,
});

export { sentimentTrackerRootReducer };
